import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { SchoolSettingsService } from "../../services/adminsettings.service";
import { StationPreferenceModifyRequest } from "../../services/StationPreferenceModifyRequest";

@Component({
	selector: "app-scanstationoptions",
	templateUrl: "./scanstationoptions.component.html",
	styleUrls: ["./scanstationoptions.css"],
})
export class ScanstationoptionsComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private userService: UserService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private dialogConfig: DynamicDialogConfig,
		private schoolSettingsService: SchoolSettingsService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		this.optionsData.SchoolID = this.dialogConfig.data.SchoolID;

		//Load Data
		this.loadPenaltyList();
	}

	optionsData = {
		SchoolID: 0,
		TimeScanningMode: false,
		PrintLatePassIfTardy: false,
		PrintPicOnLatePass: false,
		ShowScheduleOnLatePass: false,
		PrintScheduleInLunch: false,
		PrintStudentCutReport: false,
		CourseScanningEnabled: false,
		EnableOutOfUniformCheck: false,

		DefaultPenaltyID: -1,
		ValidScanSoundFile: "",
		SoundFile: "",
		EarlyExitUnexcusedSoundFile: "",
		EarlyExitExcusedSoundFile: "",
		InvalidCardSoundFile: "",
		BlockListSoundFile: "",
		BehaviorID: "2",

		DefaultTardyReason: {
			ExcuseID: -1,
			ExcuseCD: "",
			ExcuseDesc: "Loading -",
			Active: false,
		},
		DefaultExitReason: {
			ExcuseID: -1,
			ExcuseCD: "",
			ExcuseDesc: "Loading -",
			Active: false,
		},
		DefaultAbsentReason: {
			ExcuseID: -1,
			ExcuseCD: "",
			ExcuseDesc: "Loading -",
			Active: false,
		},

		StationPassEnable: false,
	};

	lstStationPass: any = [];

	user: any;
	errorMessage: any;
	SSPList: any = [];
	PenaltyList: any = [];
	ExcuseList: any = [];
	SoundList: any = [];

	audio: any = new Audio();

	BehaviorList: any = [
		{
			ID: "1",
			Desc: "Scanstation must set school day on start up",
		},
		{
			ID: "2",
			Desc: "Scanstation can override calendar's school day",
		},
		{
			ID: "3",
			Desc: "Scanstation can't override calendar's school day",
		},
	];

	PenaltyLoading: boolean = false;
	ExcuseLoading: boolean = false;
	SoundLoading: boolean = false;
	PassOptionsLoading: boolean = false;
	SSPLoading: boolean = false;
	Processing: boolean = false;

	/////////////////////////////////////
	// Load Data
	/////////////////////////////////////
	private loadSSPData() {
		this.SSPLoading = true;

		if (this.DistrictUser()) {
			var result = this.schoolSettingsService.loadDUSSPList("", this.optionsData.SchoolID, this.user.personID);
			result.subscribe(
				(response) => {
					this.SSPList = response;

					this.updateData();
					this.SSPLoading = false;
				},
				(error) => {
					this.SSPLoading = false;
				}
			);
		} else {
			var result = this.schoolSettingsService.loadSSPList("", this.optionsData.SchoolID, this.user.personID);
			result.subscribe(
				(response) => {
					this.SSPList = response;
					this.updateData();
					this.SSPLoading = false;
				},
				(error) => {
					this.SSPLoading = false;
				}
			);
		}
	}

	private loadPenaltyList() {
		this.PenaltyLoading = true;

		var result = this.schoolSettingsService.loadPenaltyList("", this.optionsData.SchoolID);
		result.subscribe(
			(response) => {
				this.PenaltyList = response;
				this.optionsData.DefaultPenaltyID = this.PenaltyList[0].PenaltyID;
				this.PenaltyLoading = false;

				// this.updateData();
				this.loadExcuseList();
			},
			(error) => {
				this.PenaltyLoading = false;
			}
		);
	}

	private loadExcuseList() {
		this.ExcuseLoading = true;

		var result = this.schoolSettingsService.ScanStationSettingsExcuseSelectList(this.optionsData.SchoolID);
		result.subscribe(
			(response) => {
				this.ExcuseList = response;

				this.ExcuseList.unshift({
					ExcuseID: 0,
					ExcuseCD: "",
					ExcuseDesc: "N/A -",
					Active: true,
				});

				this.optionsData.DefaultTardyReason = this.FindExcuse(-1);
				this.optionsData.DefaultExitReason = this.FindExcuse(-1);
				this.optionsData.DefaultAbsentReason = this.FindExcuse(-1);

				this.ExcuseLoading = false;

				this.loadScanStationSoundList();
				// this.updateData();
			},
			(error) => {
				this.ExcuseLoading = false;
			}
		);
	}

	//
	//	Return ExcuseID or Unexcused if not found in list
	//
	FindExcuse(ExcuseID: number) {
		var Default = -1;

		// Start from end to find Unexcused faster
		for (var z = this.ExcuseList.length - 1; z >= 0; z--) {
			var next = this.ExcuseList[z];

			if (next.ExcuseID == ExcuseID) {
				return next;
			}
			if (next.ExcuseCD == "UNEXCUSED") {
				Default = next;

				if (ExcuseID <= 0) {
					break;
				}
			}
		}

		// If Default Unexcused isn't active, try to get the first unexcused value
		if (Default < 0) {
			for (var z = this.ExcuseList.length - 1; z >= 0; z--) {
				var next = this.ExcuseList[z];

				if (String(next.ExcuseDesc).toLowerCase().indexOf("unexcused") > 0) {
					Default = next;

					break;
				}
			}
		}

		// Otherwise use the first option
		if (Default < 0) {
			Default = this.ExcuseList[0].ExcuseID;
		}

		return Default;
	}

	private loadScanStationSoundList() {
		this.SoundLoading = true;

		var result = this.schoolSettingsService.loadScanStationSoundList("", this.optionsData.SchoolID);
		result.subscribe(
			(response) => {
				this.SoundList = response;
				this.SoundList.unshift({
					SoundLibraryID: 0,
					SoundFile: "(None)",
				});
				this.optionsData.SoundFile = this.SoundList[0].SoundFile;
				this.SoundLoading = false;

				// this.updateData();
				this.loadStationPassOptions();
			},
			(error) => {
				this.SoundLoading = false;
			}
		);
	}

	private loadStationPassOptions() {
		this.PassOptionsLoading = true;

		var result = this.schoolSettingsService.StationPassOptionSelectList(this.optionsData.SchoolID);
		result.subscribe(
			(response) => {
				this.lstStationPass = response;
				this.PassOptionsLoading = false;

				this.loadSSPData();
			},
			(error) => {
				this.PassOptionsLoading = false;
			}
		);
	}

	/////////////////////////////////////

	/////////////////////////////////////
	// Helpers
	/////////////////////////////////////
	updateData() {
		for (var i = 0; i < this.SSPList.length; i++) {
			var ssp = this.SSPList[i];

			if (ssp.KeyName == "NoPassForTardy") {
				this.optionsData.PrintLatePassIfTardy = ssp.KeyValue == "1" ? false : true; //// INVERSE
			} else if (ssp.KeyName == "ShowPhotoOnPass") {
				this.optionsData.PrintPicOnLatePass = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "ShowSchedule") {
				this.optionsData.ShowScheduleOnLatePass = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "ShowLunchSchedule") {
				this.optionsData.PrintScheduleInLunch = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "PrintStudentCutReport") {
				this.optionsData.PrintStudentCutReport = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "PeriodScanningEnabled") {
				this.optionsData.CourseScanningEnabled = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "EnableUniformCheck") {
				this.optionsData.EnableOutOfUniformCheck = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "OutOfUniform_Penality") {
				this.optionsData.DefaultPenaltyID = Number(ssp.KeyValue);
			} else if (ssp.KeyName == "ValidScanSoundFile") {
				this.optionsData.ValidScanSoundFile = String(ssp.KeyValue);
			} else if (ssp.KeyName == "AlreadyInSoundFile") {
				this.optionsData.SoundFile = String(ssp.KeyValue);
			} else if (ssp.KeyName == "EarlyExitUnexcusedSoundFile") {
				this.optionsData.EarlyExitUnexcusedSoundFile = String(ssp.KeyValue);
			} else if (ssp.KeyName == "EarlyExitExcusedSoundFile") {
				this.optionsData.EarlyExitExcusedSoundFile = String(ssp.KeyValue);
			} else if (ssp.KeyName == "DefaultBlockAlertSound") {
				this.optionsData.BlockListSoundFile = String(ssp.KeyValue);
			} else if (ssp.KeyName == "TimeScanModeEnabled") {
				this.optionsData.TimeScanningMode = ssp.KeyValue == "1" ? true : false;
			} else if (ssp.KeyName == "InvalidCardSoundFile") {
				this.optionsData.InvalidCardSoundFile = String(ssp.KeyValue);
			} else if (ssp.KeyName == "Behavior") {
				this.optionsData.BehaviorID = String(ssp.KeyValue);
			} else if (ssp.KeyName == "DefaultTardyReason") {
				this.optionsData.DefaultTardyReason = this.FindExcuse(Number(ssp.KeyValue));
			} else if (ssp.KeyName == "DefaultExitReason") {
				this.optionsData.DefaultExitReason = this.FindExcuse(Number(ssp.KeyValue));
			} else if (ssp.KeyName == "DefaultAbsentReason") {
				this.optionsData.DefaultAbsentReason = this.FindExcuse(Number(ssp.KeyValue));
			} else if (ssp.KeyName == "StationPassEnable") {
				this.optionsData.StationPassEnable = ssp.KeyValue == 1 ? true : false;
			}
		}

		this.SetDefaults();
	}

	SetDefaults() {
		if (this.optionsData.ValidScanSoundFile == undefined || this.optionsData.ValidScanSoundFile == "") {
			this.optionsData.ValidScanSoundFile = "Single_Ding.mp3";
		}
		if (this.optionsData.EarlyExitUnexcusedSoundFile == undefined || this.optionsData.EarlyExitUnexcusedSoundFile == "") {
			this.optionsData.EarlyExitUnexcusedSoundFile = "Single_Ding.mp3";
		}
		if (this.optionsData.EarlyExitExcusedSoundFile == undefined || this.optionsData.EarlyExitExcusedSoundFile == "") {
			this.optionsData.EarlyExitExcusedSoundFile = "Single_Ding.mp3";
		}
		if (this.optionsData.BlockListSoundFile == undefined || this.optionsData.BlockListSoundFile == "") {
			this.optionsData.BlockListSoundFile = "Alarm.mp3";
		}

		//
		//	Calendar Behavior Undefined
		//
		if (this.optionsData.BehaviorID != "1" && this.optionsData.BehaviorID != "2" && this.optionsData.BehaviorID != "3") {
			this.optionsData.BehaviorID = "2";
		}
	}

	BoolToInt(val) {
		return val ? 1 : 0;
	}

	GetStationPassString(): string {
		var str = "";

		for (var z = 0; z < this.lstStationPass.length; z++) {
			var next = this.lstStationPass[z];

			if (next.IsEnabled == true) {
				str += "1";
			} else {
				str += "0";
			}
		}

		return str;
	}

	DistrictUser() {
		return this.user.UserLevelID == 1;
	}

	dataURIToMP3Blob(val) {
		const byteString = window.atob(val);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: "audio/mpeg" });
		return blob;
	}

	/////////////////////////////////////

	/////////////////////////////////////
	// Buttons
	/////////////////////////////////////
	PlaySoundValidScan() {
		this.errorMessage = "";

		if (this.optionsData.ValidScanSoundFile == "(None)") {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		var entry;
		var SoundLibraryID;
		for (var i = 0; i < this.SoundList.length; i++) {
			if (this.SoundList[i].SoundFile == this.optionsData.ValidScanSoundFile) {
				SoundLibraryID = this.SoundList[i].SoundLibraryID;
				entry = this.SoundList[i];
				break;
			}
		}

		//Get Sound's data from DB
		var SoundData;
		var result = this.schoolSettingsService.loadSoundFile("", SoundLibraryID);
		result.subscribe(
			(response) => {
				//SoundData = response;

				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	PlaySoundStudentAlreadyIn() {
		this.errorMessage = "";

		if (this.optionsData.SoundFile == "(None)") {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		var entry;
		var SoundLibraryID;
		for (var i = 0; i < this.SoundList.length; i++) {
			if (this.SoundList[i].SoundFile == this.optionsData.SoundFile) {
				SoundLibraryID = this.SoundList[i].SoundLibraryID;
				entry = this.SoundList[i];
				break;
			}
		}

		//Get Sound's data from DB
		var SoundData;
		var result = this.schoolSettingsService.loadSoundFile("", SoundLibraryID);
		result.subscribe(
			(response) => {
				//SoundData = response;

				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	PlaySoundEarlyExitUnexcused() {
		this.errorMessage = "";

		if (this.optionsData.SoundFile == "(None)") {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		var entry;
		var SoundLibraryID;
		for (var i = 0; i < this.SoundList.length; i++) {
			if (this.SoundList[i].SoundFile == this.optionsData.EarlyExitUnexcusedSoundFile) {
				SoundLibraryID = this.SoundList[i].SoundLibraryID;
				entry = this.SoundList[i];
				break;
			}
		}

		//Get Sound's data from DB
		var SoundData;
		var result = this.schoolSettingsService.loadSoundFile("", SoundLibraryID);
		result.subscribe(
			(response) => {
				//SoundData = response;

				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	PlaySoundEarlyExitExcused() {
		this.errorMessage = "";

		if (this.optionsData.SoundFile == "(None)") {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		var entry;
		var SoundLibraryID;
		for (var i = 0; i < this.SoundList.length; i++) {
			if (this.SoundList[i].SoundFile == this.optionsData.EarlyExitExcusedSoundFile) {
				SoundLibraryID = this.SoundList[i].SoundLibraryID;
				entry = this.SoundList[i];
				break;
			}
		}

		//Get Sound's data from DB
		var SoundData;
		var result = this.schoolSettingsService.loadSoundFile("", SoundLibraryID);
		result.subscribe(
			(response) => {
				//SoundData = response;

				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	PlaySoundBlockList() {
		this.errorMessage = "";

		if (this.optionsData.SoundFile == "(None)") {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		var entry;
		var SoundLibraryID;
		for (var i = 0; i < this.SoundList.length; i++) {
			if (this.SoundList[i].SoundFile == this.optionsData.BlockListSoundFile) {
				SoundLibraryID = this.SoundList[i].SoundLibraryID;
				entry = this.SoundList[i];
				break;
			}
		}

		//Get Sound's data from DB
		var SoundData;
		var result = this.schoolSettingsService.loadSoundFile("", SoundLibraryID);
		result.subscribe(
			(response) => {
				//SoundData = response;

				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	StopSound() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}

	PlaySoundInvalidCard() {
		this.errorMessage = "";

		if (this.optionsData.InvalidCardSoundFile == "(None)") {
			//Error message
			this.errorMessage = "Select a sound to play";

			return;
		}

		var entry;
		var SoundLibraryID;
		for (var i = 0; i < this.SoundList.length; i++) {
			if (this.SoundList[i].SoundFile == this.optionsData.InvalidCardSoundFile) {
				SoundLibraryID = this.SoundList[i].SoundLibraryID;
				entry = this.SoundList[i];
				break;
			}
		}

		//Get Sound's data from DB
		var SoundData;
		var result = this.schoolSettingsService.loadSoundFile("", SoundLibraryID);
		result.subscribe(
			(response) => {
				//SoundData = response;

				//
				//Create Mp3 File
				//

				//Get base64 Data
				var base64 = response[0];

				//Turn data into sound blob (formatted raw data)
				var soundBlob = this.dataURIToMP3Blob(base64);

				//Create URL from the soud blob
				var url = window.URL.createObjectURL(soundBlob);

				//Open file for testing purposes
				//var pwa = window.open(url);

				this.audio.src = url;
				this.audio.load();
				this.audio.play();
				//this.audio.currentTime = 0;
			},
			(error) => {}
		);
	}

	ClearValidScanSound() {
		this.optionsData.ValidScanSoundFile = this.SoundList[0].SoundFile;
	}

	ClearSound() {
		this.optionsData.SoundFile = this.SoundList[0].SoundFile;
	}

	ClearEarlyExitUnexcusedSound() {
		this.optionsData.EarlyExitUnexcusedSoundFile = this.SoundList[0].SoundFile;
	}

	ClearEarlyExitExcusedSound() {
		this.optionsData.EarlyExitExcusedSoundFile = this.SoundList[0].SoundFile;
	}

	ClearInvalidSound() {
		this.optionsData.InvalidCardSoundFile = this.SoundList[0].SoundFile;
	}

	ClearBlockListSound() {
		this.optionsData.InvalidCardSoundFile = this.SoundList[0].SoundFile;
	}

	onUpdate() {
		if (this.optionsData.DefaultTardyReason.Active == false) {
			this.errorMessage =
				`Default Tardy Reason is Inactive and will not Sync to ScanStation. Please pick a different Default Tardy Reason or Reactivate "` +
				this.optionsData.DefaultTardyReason.ExcuseCD +
				` - ` +
				this.optionsData.DefaultTardyReason.ExcuseDesc +
				`"`;
			return;
		}
		if (this.optionsData.DefaultExitReason.Active == false) {
			this.errorMessage =
				`Default Exit Reason is Inactive and will not Sync to ScanStation. Please pick a different Default Exit Reason or Reactivate "` +
				this.optionsData.DefaultExitReason.ExcuseCD +
				` - ` +
				this.optionsData.DefaultExitReason.ExcuseDesc +
				`"`;
			return;
		}
		// if (this.optionsData.DefaultAbsentReason.Active == false) {
		// 	this.errorMessage =
		// 		`Default Absent Reason is Inactive and will not Sync to ScanStation. Please pick a different Default Absent Reason or Reactivate "` +
		// 		this.optionsData.DefaultAbsentReason.ExcuseCD +
		// 		` - ` +
		// 		this.optionsData.DefaultAbsentReason.ExcuseDesc +
		// 		`"`;
		// 	return;
		// }

		var inversePrintLatePass;
		if (this.optionsData.PrintLatePassIfTardy == true) {
			inversePrintLatePass = false;
		} else {
			inversePrintLatePass = true;
		}

		var parms: StationPreferenceModifyRequest = {
			SchoolID: this.optionsData.SchoolID,
			PrintLatePassIfTardy: this.BoolToInt(inversePrintLatePass),
			PrintPicOnLatePass: this.BoolToInt(this.optionsData.PrintPicOnLatePass),
			ShowScheduleOnLatePass: this.BoolToInt(this.optionsData.ShowScheduleOnLatePass),
			PrintScheduleInLunch: this.BoolToInt(this.optionsData.PrintScheduleInLunch),
			PrintStudentCutReport: this.BoolToInt(this.optionsData.PrintStudentCutReport),
			CourseScanningEnabled: this.BoolToInt(this.optionsData.CourseScanningEnabled),
			EnableOutOfUniformCheck: this.BoolToInt(this.optionsData.EnableOutOfUniformCheck),
			DefaultPenaltyID: this.optionsData.DefaultPenaltyID,
			ValidScanSoundFile: this.optionsData.ValidScanSoundFile,
			SoundFile: this.optionsData.SoundFile,
			EarlyExitUnexcusedSoundFile: this.optionsData.EarlyExitUnexcusedSoundFile,
			EarlyExitExcusedSoundFile: this.optionsData.EarlyExitExcusedSoundFile,
			BlockListSoundFile: this.optionsData.BlockListSoundFile,
			BehaviorID: this.optionsData.BehaviorID,
			DefaultTardyReason: Number(this.optionsData.DefaultTardyReason.ExcuseID),
			DefaultExitReason: Number(this.optionsData.DefaultExitReason.ExcuseID),
			DefaultAbsentReason: Number(this.optionsData.DefaultAbsentReason.ExcuseID),
			TimeScanningMode: this.BoolToInt(this.optionsData.TimeScanningMode),
			InvalidCardSoundFile: this.optionsData.InvalidCardSoundFile,
			StationPassEnable: this.BoolToInt(this.optionsData.StationPassEnable),
			StationPass: this.GetStationPassString(),
		};

		this.Processing = true;

		if (this.DistrictUser()) {
			var result = this.schoolSettingsService.UpdateScanStationPrefDU(parms);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "ScanStation Settings were Successfully Updated",
							header: "ScanStation Settings",
							icon: "fa",
							accept: () => {},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Update ScanStation Preferences",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {
					this.Processing = false;
				}
			);
		} else {
			var result = this.schoolSettingsService.UpdateScanStationPref(parms);
			result.subscribe(
				(response) => {
					this.Processing = false;

					if (response) {
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "ScanStation Settings were Successfully Updated",
							header: "ScanStation Settings",
							icon: "fa",
							accept: () => {},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not Update ScanStation Preferences",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {
					this.Processing = false;
				}
			);
		}
	}

	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}

	/////////////////////////////////////

	/////////////////////////////////////
	// Events
	/////////////////////////////////////

	onSoundChange() {
		this.errorMessage = "";
	}

	/////////////////////////////////////

	/////////////////////////////////////
	// Helpers
	/////////////////////////////////////

	IsLoading() {
		return (
			this.PenaltyLoading == true ||
			this.ExcuseLoading == true ||
			this.SoundLoading == true ||
			this.PassOptionsLoading == true ||
			this.SSPLoading == true ||
			this.Processing == true
		);
	}

	/////////////////////////////////////
}
